.productDetailsContainer {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 512px;
}
